module.exports = __webpack_public_path__ + "img/第7章_3-1_高賓閣.jpg";